import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import { NgModule } from '@angular/core';

import { Environment } from './environment/environment.interface';
import { HttpRequestInterceptor } from './interceptors/http-request.interceptor';

@NgModule({
	imports: [
		HttpClientModule
	]
})
export class CoreModule {

	public static forRoot(environment: Environment): ModuleWithProviders {
		return {
				ngModule: CoreModule,
				providers: [
					{
						provide: 'environment',
						useValue: environment
					},
					{
						provide: HTTP_INTERCEPTORS,
						useClass: HttpRequestInterceptor,
						multi: true
					}
				]
		};
}
}
